/**
 * The columns the Docs navigation list asks PostgREST for.
 *
 * `body` IS DELIBERATELY ABSENT, and that absence is the whole point.
 *
 * The Docs screen exists to be read on a phone. Selecting `*` here fetched
 * every document's full text on every visit -- 328 kB across 11 documents,
 * including archives nobody had opened -- in order to render a sidebar of
 * eleven titles. Without `body` the same list is about 2.5 kB, and it stays
 * flat however long the manual grows; the open document's body is fetched on
 * its own, once, by `useDocBody`.
 *
 * It lives in its own file so a Node test can hold it to that. Restoring
 * `body` here is invisible in development -- the screen looks identical and
 * behaves identically on a fast connection -- while silently reinstating the
 * entire payload. That is exactly the kind of regression a browser test would
 * also miss, so the guard is a plain assertion on this array.
 */
export const DOC_LIST_COLUMNS = [
  "id",
  "slug",
  "title",
  "summary",
  "ord",
  "source_path",
  "updated_at",
] as const;
